// import './main.css'
import './output.css'
import App from './src/App'

export default App
